import CarouselLayout from "../../components/carousel/CarouselLayout";
import { useEffect } from "react";
import { Loader, Text, Title, Grid, Image } from "@mantine/core";
import { useCarousel } from "../../api/CarouselContext";
import { useNavigate } from "react-router-dom";
import screenText from "../../content/text";
import "./Home.css";
import Train from "../../components/train/train";
import { useHome } from "../../api/HomeContext";
import Socials from "../../components/social/socials";

import brimfieldImage from "../../components/assets/View_Our_Brimfield_Picks.png";

const loaderStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
};

const carouselLoaderStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: 500,
  width: "100%",
};

function Home() {
  const { getCarouselAssets, carouselState } = useCarousel();
  const { getHomeAssets, homeState } = useHome();
  const navigate = useNavigate(); // Initialize the navigate function
  useEffect(() => {
    if (!carouselState.loading && !carouselState.data.length) {
      getCarouselAssets();
    }
    if (!homeState.loading && !homeState.data.length) {
      getHomeAssets();
    }
  }, []);

  const handleButtonClick = () => {
    navigate("/brimfield");
  };

  return (
    <div>
      <div>
        <Grid container spacing={2}>
          {/* <Grid.Col
            span="auto"
            className="responsiveImageContainer" // Add a class for responsive behavior
          >
            <Image
              src={brimfieldImage}
              alt="Clickable Button"
              maw={200}
              onClick={handleButtonClick}
              style={{ cursor: "pointer" }}
            />
          </Grid.Col> */}
          <Grid.Col md={12} sm={12} xs={12}>
            <Title className="titleContainer">{screenText.home.title}</Title>
            <Text className="subTitleHeader" fs="italic">
              {screenText.home.subtitle}
            </Text>
          </Grid.Col>
          <Grid.Col span="auto"></Grid.Col>
        </Grid>
        {carouselState.loading && (
          <div style={carouselLoaderStyle}>
            <Loader />
          </div>
        )}
        {carouselState?.data.length ? (
          <CarouselLayout data={carouselState.data} />
        ) : null}
        <div className="trainContainer">
          <Train />
        </div>
        <Grid className="descriptionContainer">
          <Grid.Col md={6} sm={12} xs={12}>
            {homeState.loading && (
              <div style={loaderStyle}>
                <Loader />
              </div>
            )}
            {homeState?.data.length ? (
              <Image maw={800} src={homeState.data[0]} radius="sm" />
            ) : null}
          </Grid.Col>
          <Grid.Col md={6} sm={12} xs={12}>
            <Title className="descriptionTitle">
              {screenText.home.descriptionTitle}
            </Title>
            <Text className="descriptionText">
              {screenText.home.description}
            </Text>
            <Text className="socialMediaText">
              {screenText.home.socialMediaText}
            </Text>
            <Socials />
          </Grid.Col>
        </Grid>
      </div>
    </div>
  );
}

export default Home;
